import { Button } from '@/components/form/Button';
import { DecorativeCard } from '@/layouts/DecorativeCard';
import { useCompany } from '@/services/api/hooks/companies';
import { usePartner } from '@/services/api/hooks/partners';
import { RoleType, useRole } from '@/services/authentication/hooks/user';
import { useNavigate } from 'react-router';
import Balancer from 'react-wrap-balancer';

const useOrganisation = () => {
  const role = useRole();
  if (role.type === RoleType.Company && role.partnerId && role.customerId) {
    // This role can never change during the lifetime of the app
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCompany(role.partnerId, role.customerId);
  }

  if (role.type === RoleType.Partner && role.partnerId) {
    // This role can never change during the lifetime of the app
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePartner(role.partnerId);
  }

  throw new Error('No organisation found');
};

export const Disabled = () => {
  const [organisation] = useOrganisation();
  const navigate = useNavigate();

  return (
    <DecorativeCard className="flex w-full max-w-2xl flex-col items-center gap-8 p-16">
      <h1 className="text-center text-4xl font-bold">
        <Balancer>{organisation.name} has been disabled.</Balancer>
      </h1>
      <div>
        <p className="font-medium text-center">
          {`We're sorry, the organisation that you have signed into has been disabled. Please contact DaaS Portal if you
          believe this is a mistake.`}
        </p>
        <Button onClick={() => navigate('/auth/signout')} className="mt-8 w-full">
          Sign out of {organisation.name}
        </Button>
      </div>
    </DecorativeCard>
  );
};
